import * as React from "react";
import { PlaceholderBtn } from "./PlaceholderBtn";
import { PlaceholderInfo } from "./PlaceholderInfo";

export class Placeholder extends React.PureComponent<{eventsCount: number}, {}>
{
    renderItems(eventsCount: number) {
        let elements: JSX.Element[] = [];
        for (let i = 1; i <= eventsCount; i++) {
            elements.push(
                <div key={`placeholder_item_${i}`} className="rj-ev-list__placeholder__card-items-wrap">
                    <PlaceholderInfo />
                    <PlaceholderBtn />
                </div>
            )
        }
        return elements
    }
    render() {
        return (
            <div className="rj-ev-list__placeholder">
                <div className="rj-ev-list__placeholder__header">
                    <div className="rj-ev-list__placeholder__header-text"></div>
                </div>
                {this.renderItems(this.props.eventsCount)}
            </div>
        )
    }
}